import React from "react"
import ReactDOM from "react-dom/client"

import App from "./App"
import reportWebVitals from "./reportWebVitals"

import "./design/css/app.css"
import "./design/css/input.css"
import "./design/css/authorization.css"
import "./design/css/layout.css"
import "./design/css/dashboard.css"
import "./design/css/menu.css"
import "./design/css/header.css"
import "./design/css/page.css"
import "./design/css/organization.css"
import "./design/css/toast.css"
import "./design/css/pagination.css"
import "./design/css/booking.css"
import "./design/css/queue.css"
import "./design/css/members.css"
import "./design/css/review.css"
import "./design/css/support.css"
import "./design/css/timefilter.css"
import "./design/css/arrayfilter.css"
import "./design/css/notification.css"
import "./design/css/flyer.css"
import "./design/css/category.css"
import "./design/css/service.css"
import "./design/css/user.css"
import "./design/css/master.css"
import "./design/css/transaction.css"
import "./design/css/otp.css"
import "./design/css/admin.css"
import "./design/css/settings.css"
import "./design/css/inbox.css"
import "./design/css/lead.css"
import "./design/css/promo.css"
import 'react-datepicker/dist/react-datepicker.css'

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<App />)

reportWebVitals()